// extracted by mini-css-extract-plugin
export default {"popupContainer":"popup_popupContainer","popupInner":"popup_popupInner","btnClose":"popup_btnClose"};